import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 's18-platform-connect-stripe',
  templateUrl: './platform-connect-stripe.component.html',
  styleUrls: ['./platform-connect-stripe.component.scss']
})
export class PlatformConnectStripeComponent implements OnInit {

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  close(){
    this.dialog.closeAll();
  }

}
